import { db } from './../config/Fire';
import * as Constants from './../constants/nodes_database';

export const SET_ACTIVE_RESTAURANT_ADMIN = 'SET_ACTIVE_RESTAURANT_ADMIN';
export const SET_ERROR_RESTAURANT_ADMIN = 'SET_ERROR_RESTAURANT_ADMIN';

const setActiveProp = payload => ({ type: SET_ACTIVE_RESTAURANT_ADMIN, payload });
export const setErrorRestaurant = payload => ({ type: SET_ERROR_RESTAURANT_ADMIN, payload });

export const setActivePropToRestaurant = payload => {
    return dispatch => {
        const { id, active } = payload;
        dispatch(setActiveProp({ id: id, active: !active, isLoading: true }));
        return db.ref(`${Constants.RESTAURANTS}/${id}`).update({
            active: active,
        })
        .then(() => {
                dispatch(setActiveProp({ id: id, active: active, isLoading: false }));
                dispatch(setErrorRestaurant({ state: false}));
        })
        .catch(err => {
            dispatch(setActiveProp({ id: id, active: !active, isLoading: false }));
            dispatch(setErrorRestaurant({ state: true, rason: "ERROR"}));
        });
    };
};